import React from 'react';
import { MessageList, useChannelStateContext } from 'stream-chat-react';

import { StreamMessage } from './stream-message';

export const StreamMessageList = () => {
  const { messages: streamMessages } = useChannelStateContext();

  const messages = [
    {
      id: 'header',
      type: 'header'
    },
    ...streamMessages
  ];

  return (
    <MessageList
      disableQuotedMessages
      hideDeletedMessages
      hideNewMessageSeparator
      showUnreadNotificationAlways={false}
      Message={StreamMessage}
      messages={messages}
    />
  );
};
